import { render } from "./ContainerProduction.vue.js?vue&type=template&id=080b5028!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ContainerProduction.vue?vue&type=template&id=080b5028"
import script from "./ContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ContainerProduction.vue?vue&type=script&lang=js"
export * from "./ContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ContainerProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/layouts/ContainerProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "080b5028"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('080b5028', __exports__)) {
    api.reload('080b5028', __exports__)
  }
  
  module.hot.accept("./ContainerProduction.vue.js?vue&type=template&id=080b5028!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ContainerProduction.vue?vue&type=template&id=080b5028", () => {
    api.rerender('080b5028', render)
  })

}


export default __exports__